export const CONTACT_CONFIG = {
  phoneNumber: "+44 7482789068",
  
  email: "contact@tvmarca.com",
  
  whatsappUrl: "https://wa.me/447482789068",
  
  companyName: "TVMARCA",
  
  websiteUrl: "https://tvmarca.com"
};

export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(/\s/g, '');
};

export const createWhatsAppUrl = (phoneNumber, message = "") => {
  const cleanNumber = formatPhoneNumber(phoneNumber);
  return `https://wa.me/${cleanNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};
